import { ContactInfoDto } from '../api/api';
import WorkClient from '../api/workClient';

const replaceMeter = (worktaskId: number, replace: boolean) => {
  return WorkClient.updateReplaceMeter(worktaskId, replace);
};

const getMeterTaskInfo = (worktaskId: number) => {
  return WorkClient.getMeterTaskInfo(worktaskId);
};

const addContact = (worktaskId: number, body: ContactInfoDto) => {
  return WorkClient.addContactInfo(worktaskId, body);
};

const MeterService = {
  replaceMeter,
  addContact,
  getMeterTaskInfo
};

export default MeterService;
